export default "__VITE_ASSET__DJnvjqIV__"